// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1G4_F","amount":"Amount_amount__1P1uB","tip":"Amount_tip__h1bBK","tipHeader":"Amount_tipHeader__2JxqW","tipsWrap":"Amount_tipsWrap__2iQOn"};